export const enum LanguageId {
  enZa = '9688cd08-adef-408c-9d34-5d75ae5c44df',
}
